export default class AutoLinks
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...AutoLinks.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.pattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/g

        this.DOM.$el.innerHTML = this.DOM.$el.innerHTML.replace(this.pattern, (match, $1) => {
            return "<a href=\"" + match + "\" target=\"_blank\" rel=\"noopener\">" + match + "</a>"
        });
    }
}

AutoLinks.prototype.defaults = {
}